import Vue from "vue";
import Router from "vue-router";
import Home from "./views/pages/Home.vue";
import account from "./views/pages/account.vue";
import borrow from "./views/pages/borrow.vue";
import budget from "./views/pages/budget.vue";
import expenseHeatmap from "./views/pages/expenseHeatmap.vue";
import folders from "./views/pages/folders.vue";
import goals from "./views/pages/goals.vue";
import lend from "./views/pages/lend.vue";
import settings from "./views/pages/settings.vue";
import analytics from "./views/pages/analytics.vue";
import recycle from "./views/pages/recycle.vue";
import recurring from "./views/pages/recurring.vue";
import reminders from "./views/pages/reminders.vue";
import memoir from "./views/pages/memoir.vue";
import expense from "./views/pages/expense.vue";
import notifications from "./views/pages/notifications.vue";
import subscription from "./views/pages/subscription.vue";
import translate from "./views/pages/translate.vue";
import privacypolicy from "./views/pages/privacypolicy.vue";


Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home,
    },
    {
      path: "/account",
      name: "account",
      component: account,
    },
    {
      path: "/borrow",
      name: "borrow",
      component: borrow,
    },
    {
      path: "/budget",
      name: "budget",
      component: budget,
    },
    {
      path: "/expenseHeatmap",
      name: "expenseHeatmap",
      component: expenseHeatmap,
    },
    {
      path: "/recurring",
      name: "recurring",
      component: recurring,
    },
    {
      path: "/folders",
      name: "folders",
      component: folders,
    },
    {
      path: "/goals",
      name: "goals",
      component: goals,
    },
    {
      path: "/lend",
      name: "lend",
      component: lend,
    },
    {
      path: "/settings",
      name: "settings",
      component: settings,
    },
    {
      path: "/analytics",
      name: "analytics",
      component: analytics,
    },
    {
      path: "/recycle",
      name: "recycle",
      component: recycle,
    },
    {
      path: "/reminders",
      name: "reminders",
      component: reminders,
    },
    {
      path: "/memoir",
      name: "memoir",
      component: memoir,
    },
    {
      path: "/expense",
      name: "expense",
      component: expense,
    },
    {
      path: "/notifications",
      name: "notifications",
      component: notifications,
    },
    {
      path: "/subscription",
      name: "subscription",
      component: subscription,
    },
    {
      path: "/translate",
      name: "translate",
      component: translate,
    },
    {
      path: "/privacy-policy",
      name: "privacypolicy",
      component: privacypolicy,
    },
  ],
});
